import { useEffect, useRef } from 'react';
import WebSocketManager from '../manager/WebSocketManager';
import { audioSessionTimeout } from '../utils/config';
import { delay } from '../utils/helper';
import ConsoleUtils from '../utils/console';

const webSocketManager = new WebSocketManager();
let streamData;
let isStartSession = false;
// let isListening = false;
// let isPauseListening = false;
// let stopListenEventsRef = false;
let isChatAssigned = false;

const useRecorder = ({ response }) => {
  const mediaRecorderRef = useRef(null);
  // const { widgetConfig } = useSelector((state) => ({
  //   widgetConfig: state.messages.widgetConfig,
  // }));

  const receiveMessage = (event) => {
    const message = event?.detail;

    if (message?.error) {
      ConsoleUtils.log('message error', message);
      if (message.type === 'speechToTextTimeOut') {
        response('stopListening', message?.content?.text ?? '');
        handleStopRecording();
        isChatAssigned = false;
      }
      return;
    }

    if (message?.subType === 'queue' || message?.subType === 'assign') {
      // stopListenEventsRef = true;
      isChatAssigned = true;
    }
    if (message.type === 'listening') {
      ConsoleUtils.log(
        'mediaRecorder state Listening:-',
        mediaRecorderRef.current && mediaRecorderRef.current.state
      );

      if (
        // !stopListenEventsRef &&
        mediaRecorderRef.current &&
        mediaRecorderRef.current.state !== 'recording'
      ) {
        ConsoleUtils.log('Listening Called');

        handleStartListening();

        // if (
        //   widgetConfig?.widgetConfig?.currentStatus === 'assigned' ||
        //   widgetConfig?.widgetConfig?.currentStatus === 'queue'
        // ) {
        //   stopListenEventsRef = true;
        // }
        // if (isChatAssigned) {
        //   stopListenEventsRef = true;
        // }
      }
    } else if (message.type === 'pauseListening') {
      // ConsoleUtils.log(
      //   'mediaRecorder state Pause Listening:-',
      //   mediaRecorderRef.current && mediaRecorderRef.current.state
      // );
      if (
        // !stopListenEventsRef &&
        mediaRecorderRef.current &&
        mediaRecorderRef.current.state === 'recording'
      ) {
        ConsoleUtils.log('Pause listening Called');

        // isPauseListening = true;

        mediaRecorderRef.current.stop();
        handleStopRecording();
        delay(500);
        // ConsoleUtils.log('stopListenEventsRef:-', stopListenEventsRef);

        // if (stopListenEventsRef) {
        //   handleStartListening();
        // }
        // handleResetRecorder();
        response('dictationMessage', '');
      } else {
        response('dictationMessage', 'Listening...');
      }
    } else if (message.type === 'dictation') {
      // On interept to stop audio
      response('dictationEvent', message?.content?.text);
    } else if (message.type === 'typing') {
      response('dictationMessage', 'Bot Responding...');
    } else if (message.type === 'stopListening' || message.type === 'speechToTextTimeOut') {
      response('stopListening', message?.content?.text ?? '');
      handleStopRecording();
      isChatAssigned = false;
    } else if (message.type === 'close') {
      response('endSession', '');
      handleStopRecording();
      isChatAssigned = false;
    } else if (message.type === 'audioBuffer') {
      response('audioBuffer', message);
    } else if (message.type === 'text' && message.from === 'customer') {
      response('dictationMessage', 'Listening...');
    }

    if (message?.mode === 'start' || message?.mode === 'continue') {
      response('dictationMessage', 'Bot Responding...');
    }

    if (message?.mode === 'stop') {
      response('dictationMessage', 'Listening...');
    }
  };

  useEffect(() => {
    // webSocketManager.addListener('message', receiveMessage);
    window.addEventListener('receiveMessage', receiveMessage);
    // Cleanup function to stop media stream and hark on component unmount
    return () => {
      // webSocketManager.removeListener('message', receiveMessage);
      window.removeEventListener('receiveMessage', receiveMessage);
      if (mediaRecorderRef?.current?.state === 'recording') {
        mediaRecorderRef.current.stop();
      }
    };
  }, []);

  if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
    response('hideMicrophone', true);
  }
  if (typeof MediaRecorder === 'undefined') {
    alert(
      'MediaRecorder not supported on your browser. Please use a compatible browser such as Safari 14+'
    );
  }

  const getAudioBuffer = async () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.addEventListener('dataavailable', (event) => {
        // ConsoleUtils.log(`dataavailable push data`, event);
        const audioBlob = new Blob([event.data], { type: 'audio/webm' });

        // Convert Blob to Base64
        const reader = new FileReader();
        reader.readAsDataURL(audioBlob);
        reader.onloadend = () => {
          const base64Audio = reader.result.split(',')[1]; // Get only the base64 data part
          response('partialAudio', base64Audio); // Send Base64 string
        };
      });
    }
  };

  const getMicrophonePermission = async () => {
    try {
      // Check if the Permissions API is supported
      if (navigator.permissions) {
        const permissionStatus = await navigator.permissions.query({ name: 'microphone' });

        if (permissionStatus.state === 'denied') {
          response('permissionDenied', 'Please allow microphone access.');
          return;
        }
      }

      // Request microphone access
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

      if (!stream) {
        response('permissionDenied', 'Microphone access was not granted.');
        return;
      }

      // Check if MediaRecorder is supported
      if (typeof MediaRecorder === 'undefined') {
        response('permissionDenied', 'MediaRecorder is not supported in this browser.');
        return;
      }

      return { stream: stream, success: true };
    } catch (error) {
      ConsoleUtils.log('Microphone access error:', error);

      let errorMessage = 'Microphone access denied.';
      if (error.name === 'NotAllowedError') {
        errorMessage = 'Please allow permissions.';
      } else if (error.name === 'NotFoundError' || error.name === 'DevicesNotFoundError') {
        errorMessage = 'No microphone found.';
      } else if (error.name === 'NotReadableError') {
        errorMessage = 'Microphone is being used by another application.';
      }

      response('permissionDenied', errorMessage);
    }
  };

  const handleStartRecording = async (isRestart = false) => {
    const permission = await getMicrophonePermission();
    ConsoleUtils.log('Handle Start recording', permission);

    if (permission?.success) {
      isStartSession = true;
      streamData = permission.stream;
      mediaRecorderRef.current = new MediaRecorder(permission.stream, {
        mimeType: 'audio/webm; codecs=opus',
      });
      getAudioBuffer();
      if (!isRestart) {
        response('startEvent', '');
      } else {
        handleStartListening();
      }
      // setTimeout(
      //   () => {
      //     if (!isListening) {
      //       handleStopRecording();
      //       response('permissionDenied', 'Bot not responding...');
      //       response('sessionTimeout', '');
      //       isListening = false;
      //     }
      //   },
      //   audioSessionTimeout * 1000 || 15000
      // );
    }
  };

  const handleStopRecording = () => {
    ConsoleUtils.log('stopped speaking ----- ', mediaRecorderRef);
    if (mediaRecorderRef?.current?.state === 'recording') mediaRecorderRef.current.stop();
    streamData?.getTracks()?.forEach((track) => track.stop());
    isStartSession = false;
    // stopListenEventsRef = false;
  };

  // const handleResetRecorder = async () => {
  //   ConsoleUtils.log('Handle Reset Recorder');
  //   if (mediaRecorderRef?.current?.state === 'recording') mediaRecorderRef.current.stop();
  //   streamData?.getTracks()?.forEach((track) => track.stop());
  //   mediaRecorderRef.current = null;
  //   stopListenEventsRef = false;
  //   delay(500);
  //   ConsoleUtils.log('Get befor permission', mediaRecorderRef.current);

  //   const permission = await getMicrophonePermission();
  //   if (permission?.success) {
  //     streamData = permission.stream;
  //     mediaRecorderRef.current = new MediaRecorder(permission.stream, {
  //       mimeType: 'audio/webm; codecs=opus',
  //     });
  //     getAudioBuffer();
  //   }
  // };

  const handleStartListening = () => {
    if (
      isStartSession &&
      mediaRecorderRef.current &&
      mediaRecorderRef.current.state !== 'recording'
    ) {
      // isListening = true;
      mediaRecorderRef.current.start(250);
      response('dictationMessage', 'Listening...');
      // setTimeout(
      //   () => {
      //     if (
      //       !isPauseListening
      //       // && !stopListenEventsRef
      //     ) {
      //       handleStopRecording();
      //       response('permissionDenied', 'Please tell us something...');
      //       response('sessionTimeout', '');
      //       isPauseListening = false;
      //     }
      //   },
      //   audioSessionTimeout * 1000 || 15000
      // );
    } else {
      handleStartRecording(true);
    }
  };

  return {
    handleStartRecording,
    handleStopRecording,
  };
};

export default useRecorder;
